import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import { CookiesProvider } from "react-cookie";


import "react-toastify/dist/ReactToastify.css";
import Layout from "../components/Layout/Layout";
import ErrorPage from "../containers/ErrorPage/ErrorPage";
import VideoDescription from "../containers/VideoDescription/VideoDescription";
import Home from "../containers/Home/Home";
/* const DOIRedirect = React.lazy(() =>
  import("../containers/DOIRedirect/DOIRedirect")
); */// Lazy-loaded


const ProtectedRoute = () => {

    return (
            <CookiesProvider>
            <Layout>
                <Routes>                             
                <Route path="/video/:id" element={<VideoDescription />} />
                <Route path="/home" element={<Home />} />
                <Route path="/welcome" element={ <Home />} />
                <Route path="/" element={<Home />} />                
                <Route path="*" element={ <Home />} />
                </Routes>
            </Layout>
            </CookiesProvider>
    )

};

export default ProtectedRoute;